import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, CalendarCheck, UserPlus, LogOut, Eye } from "lucide-react";
import { toast } from "sonner";
import { auth } from "../lib/api";

const fmt = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

export const GuestBanner = ({ user }) => {
  const navigate = useNavigate();
  const [left, setLeft] = useState(() => Math.max(0, Math.floor((new Date(user.guest_expires_at) - Date.now()) / 1000)));

  useEffect(() => {
    const id = setInterval(() => setLeft(Math.max(0, Math.floor((new Date(user.guest_expires_at) - Date.now()) / 1000))), 1000);
    const blocked = () => toast.info("Read-only demo — book a live demo or sign up to make changes.", { id: "guest-ro" });
    window.addEventListener("tr-guest-blocked", blocked);
    return () => { clearInterval(id); window.removeEventListener("tr-guest-blocked", blocked); };
  }, [user.guest_expires_at]);

  useEffect(() => {
    if (left === 0) { auth.logout(); window.location.href = "/scan?expired=1"; }
  }, [left]);

  const exit = () => { auth.logout(); navigate("/scan"); };
  return (
    <div className="bg-gradient-to-r from-amber-500/20 via-amber-400/10 to-transparent border-b border-amber-400/30 px-4 md:px-6 py-2 flex items-center justify-between gap-3 flex-wrap" data-testid="guest-banner">
      <div className="flex items-center gap-2 text-xs text-amber-100 min-w-0">
        <Eye className="w-3.5 h-3.5 text-amber-300 shrink-0" />
        <span className="truncate"><strong>Demo mode</strong> · read-only sandbox for {user.name?.split(" ")[0] || "you"}</span>
        <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 tabular-nums ${left < 300 ? "bg-rose-500/20 text-rose-200" : "bg-white/10 text-amber-200"}`} data-testid="guest-countdown"><Clock className="w-3 h-3" /> {fmt(left)} left</span>
      </div>
      <div className="flex items-center gap-2 text-xs">
        <button onClick={() => navigate("/request-demo")} className="inline-flex items-center gap-1 rounded-full bg-cyan-400 text-on-accent font-semibold px-3 py-1 hover:opacity-90" data-testid="guest-book-demo-btn"><CalendarCheck className="w-3.5 h-3.5" /> Book a live demo</button>
        <button onClick={() => navigate("/signup")} className="inline-flex items-center gap-1 rounded-full border border-amber-400/40 text-amber-200 px-3 py-1 hover:bg-amber-400/10" data-testid="guest-signup-btn"><UserPlus className="w-3.5 h-3.5" /> Sign up</button>
        <button onClick={exit} className="inline-flex items-center gap-1 text-slate-400 hover:text-white px-2" data-testid="guest-exit-btn"><LogOut className="w-3.5 h-3.5" /> Exit</button>
      </div>
    </div>
  );
};
